import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { BsArrowBarRight } from "react-icons/bs";
import { Link } from "react-router-dom";
import { MdGridView, MdOutlineFormatListBulleted, MdOutlineInfo } from "react-icons/md";
import { Modal, ToggleButton } from "react-bootstrap";
import { CgArrowsShrinkH, CgArrowsShrinkV } from "react-icons/cg";
import ComponentColideeButtonEspaces from "../public/orgunit/ComponentColideeButtonEspaces";

const ComponentTitle = (props) => {
  const { t } = useTranslation();

  const {
    title,
    seeMore,
    popupInfo,
    overflowID,
    infoView,
    setInfoView,
    afficheBoutonGrille,
    emulateH2,
    liensParticipationColidee,
    etiquetteAnimateur,
  } = props;
  const [show, setShow] = useState(false);

  const overflowToggle = (overflowID) => {
    const overflowBloc = document.getElementById(overflowID);
    if (overflowBloc.classList.contains("overflowContent")) {
      overflowBloc.classList.remove("overflowContent");
      overflowBloc.classList.add("disableOverflowContent");
      document.getElementById("buttonDisableOverflowContent" + overflowID).classList.add("d-none");
      document.getElementById("buttonOverflowContent" + overflowID).classList.remove("d-none");
    } else {
      overflowBloc.classList.remove("disableOverflowContent");
      overflowBloc.classList.add("overflowContent");
      document
        .getElementById("buttonDisableOverflowContent" + overflowID)
        .classList.remove("d-none");
      document.getElementById("buttonOverflowContent" + overflowID).classList.add("d-none");
    }
  };

  return (
    <h1
      className="mt-5 mb-3 pb-2 border-bottom  d-flex flex-end align-items-center"
      style={{ position: "relative" }}
    >
      <span style={emulateH2 && { fontSize: "2rem" }}>{title}</span>
      <Modal size="lg" show={show} onHide={() => setShow(!show)}>
        <Modal.Header closeButton>
          <Modal.Title>{title ? title : t("public.componentOrgUnit.modalTitle")}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ whiteSpace: "pre-wrap" }}>{popupInfo}</Modal.Body>
      </Modal>
      {afficheBoutonGrille && (
        <span role="button" className="ms-2">
          {!infoView ? (
            <MdGridView size="0.8em" onClick={(e) => setInfoView(!infoView)} />
          ) : (
            <MdOutlineFormatListBulleted size="0.8em" onClick={(e) => setInfoView(!infoView)} />
          )}
        </span>
      )}

      {popupInfo && (
        <span role="button" className="ms-2">
          <MdOutlineInfo
            role="button"
            size="0.8em"
            onClick={() => setShow(!show)}
            className="text-danger"
          />
        </span>
      )}

      {overflowID && (
        <span role="button" className="ms-2">
          <CgArrowsShrinkV
            size="0.8em"
            className=""
            id={"buttonDisableOverflowContent" + overflowID}
            onClick={() => overflowToggle(overflowID)}
          />
          <CgArrowsShrinkH
            size="0.8em"
            className="d-none"
            id={"buttonOverflowContent" + overflowID}
            onClick={() => overflowToggle(overflowID)}
          />
        </span>
      )}

      {seeMore && (
        <Link
          style={{ position: "absolute", right: "0" }}
          className="persoBackColor containerSeeMore d-flex justify-content-center align-items-center"
          to={seeMore}
        >
          <BsArrowBarRight role="button" size="0.7em" />
        </Link>
      )}

      {liensParticipationColidee.length > 0 && (
        <ComponentColideeButtonEspaces
          emplacement="detailOrgunit"
          espacesColideeOrgunit={liensParticipationColidee}
          etiquetteAnimateur={etiquetteAnimateur}
        />
      )}
    </h1>
  );
};

ComponentTitle.defaultProps = {
  liensParticipationColidee: [],
};

export default ComponentTitle;
